import React, {useEffect} from "react";
import RichText from "./types/richText";
import Heading from "./types/heading";
import Lead from "./types/lead";
import Quote from "./types/quote";
import Image from "./types/image";
import ImageCarousel from "./types/imageCarousel";
import Embed from "./types/embed";
import TwoColumn from "./types/twoColumn";
import Button from "./types/button";
import RelatedTeamMembers from "./types/relatedTeamMembers";
import RelatedNews from "./types/relatedNews";
import Download from "./types/download";
import RelatedProjects from "./types/relatedProjects";
import RelatedGalleries from "./types/relatedGalleries";
import MediaBlockGroup from "./types/groups/mediaBlockGroup";
import TextPanel from "./types/textPanel";
import PersonGroup from "./types/groups/personGroup";
import VideoGroup from "./types/groups/videoGroup";
import ImageGroup from "./types/groups/imageGroup";
import Office from "./types/office";
import RelatedCard from "./types/relatedCard";
import LatestProjects from "./types/latestProjects";
import relatedTeamMembersVideos from "./types/relatedTeamMembersVideos";
import horizontalRule from "./types/horizontalRule";
import logoStrip from "./types/logoStrip";
import sslnDocuments from "./types/sslnDocuments";
import sadaMultiPopUpImage from "./types/sadaMultiPopUpImage";
import agywAccordions from "./types/agywAccordions";
import brochure from "./types/brochure";
import videoAndBrochures from "./types/videoAndBrochures"
import CardGrid from "./types/cardGrid";

const components = {
  richText: RichText,
  image: Image,
  imageCarousel: ImageCarousel,
  quote: Quote,
  embed: Embed,
  heading: Heading,
  lead: Lead,
  twoColumn: TwoColumn,
  button: Button,
  relatedTeamMembers: RelatedTeamMembers,
  relatedNews: RelatedNews,
  download: Download,
  relatedProjects: RelatedProjects,
  relatedGalleries: RelatedGalleries,
  textPanel: TextPanel,
  relatedCard: RelatedCard,
  offices:Office,
  latestProjects: LatestProjects,
  relatedTeamMembersVideos: relatedTeamMembersVideos,
  horizontalRule: horizontalRule,
  logoStrip: logoStrip,
  sslnDocuments: sslnDocuments,
  sadaMultiPopUpImage: sadaMultiPopUpImage,
  agywAccordions: agywAccordions,
  brochure: brochure,
  videoAndBrochures: videoAndBrochures,
  cardGrid: CardGrid,
}

const groupComponents = {
  videoGroup: VideoGroup,
  imageGroup: ImageGroup,
  personGroup: PersonGroup,
  MediaBlockGroup: MediaBlockGroup,
}

const Block = props => {
  const {group} = props
  const type = group.typeHandle

  if (Object.keys(components).includes(type)) {
    let Component = components[type]

    let buffer = []

    group.blocks.forEach((block) => {

      buffer.push(<Component block={block} key={block.id} last={props.last} />);
    });

    return (
      <div id={props.id}>{buffer}</div>
    );

  } else if (Object.keys(groupComponents).includes(type)) {

    let Component = groupComponents[type];
    return (<Component blocks={group.blocks} last={props.last} />);

  } else {
    return (
      <div>
        Error. Component not found: {type} <br/>
        TYPE: {JSON.stringify(type)} <br/>
        PROPS: {JSON.stringify(props)}
      </div>
    );
  }
}


const Blocks = ({blocks}) => {

    var groups = [];
    let group =
    {
        typeHandle: "",
        blocks: [],
    };

    blocks.forEach((block, i) =>
    {
        if(group.typeHandle != block.typeHandle)
        {
            if(group.blocks.length > 0)
            {
                groups.push(group);
            }

            group = 
            {
                typeHandle: "",
                blocks: [],
            };
        }

        group.typeHandle = block.typeHandle;
        group.blocks.push(block);

        if(blocks.length - 1 == i && group.blocks.length > 0)
        {
            groups.push(group);
        }
    });

    useEffect(() => 
    {
        const script = document.createElement('script');
        script.src = "https://www.workable.com/assets/embed.js";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => 
        {
            whr(document).ready(() => 
            { 
                whr_embed(733236, {"base":"jobs","detail":"titles","zoom":"country","grouping":"none"});
            });        
        }

        return () => 
        {
            document.body.removeChild(script);
        }
    }, []);

  return (
    <>
      <div className="body-content">
        {groups.map((group, i) => (
          <Block id={`id-${group.blocks.length > 0 ? group.blocks[0].id : "error" }`} key={i} group={group} last={i === (groups.length - 1)}/>
        ))}
        <div style={{clear: "both"}}></div>
      </div>
    </>
  );
}

export default Blocks
